import type { RequiredGeneric } from '@pba/react-utils';
import { Col, Fieldset, Form, Input, Row } from 'ui';

export type NameFormValues = {
  firstName: string;
  lastName: string;
  middleName?: string;
};

type P = {
  withMiddleName?: boolean;
};

const NameFieldset = <FormValues extends NameFormValues = never>({
  withMiddleName = true,
}: RequiredGeneric<FormValues, P>) => {
  const surnameSpan = withMiddleName ? 24 : 12;

  return (
    <Fieldset legend={{ title: 'Full name' }}>
      <Row gutter={['xs', 'xs']}>
        <Col span={12}>
          <Form.Item<NameFormValues>
            label="First name"
            name="firstName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input autoComplete="given-name" />
          </Form.Item>
        </Col>
        {withMiddleName ? (
          <Col span={12}>
            <Form.Item<NameFormValues> label="Middle name" name="middleName">
              <Input />
            </Form.Item>
          </Col>
        ) : null}
        <Col span={surnameSpan}>
          <Form.Item<NameFormValues>
            label="Last name"
            name="lastName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input autoComplete="family-name" />
          </Form.Item>
        </Col>
      </Row>
    </Fieldset>
  );
};

export default NameFieldset;
